import React, { useEffect, useState } from 'react';
import {Redirect } from "react-router-dom";
import { useCoverLetter } from '../../context/CoverLetterContext';
import { 
  COVERLETTER_WORKSTYLE,
  COVERLETTER_FINALIZE, 
  COVERLETTER_STRENGTH,
  COVERLETTER_EXP_WORKHISTORY
} from '../../constants/constants';
import '../../assets/scss/app/cover-letter-screens/on-bording-screens.scss';
import WorkHistoryForm from './QuesAnsSections/WorkHistoryForm';

const WorkHistory = (props) => {
    const [back, setBack] = useState(false);
    const [next, setNext] = useState(false);
    const [redirect2, setRedirect2] = useState(null);
    const { 
      ques_ans_response,
      qa_steps_initiated,
    handlers: {

        saveQA,
        loadQA
    },
  } = useCoverLetter();

  const saveForm = (data) => {
    saveQA({ ques_ans_response: {...ques_ans_response, ...data} })
  }
  useEffect(() => {
    //browser issue, page not opening at top
    window.scrollTo(0, 0)
    loadQA()
  }, []);

  useEffect(() => {
    (next || back) && history.pushState(null, COVERLETTER_EXP_WORKHISTORY);
    next && setRedirect2(COVERLETTER_WORKSTYLE)
    // next && save()
    back && setRedirect2(COVERLETTER_STRENGTH)
  }, [back, next]);

  if (redirect2) return <Redirect to={redirect2} />

  return (
    <div className="cover-screen-outer small-screen-outer">
    <div className="screen-inner">
      <div className="block">
        <div className="progress-bar">
              <div className="bar-outer">
                  <div className="bar-inner work-style" ></div>
              </div>
              <div className="bar-levels">
                  <div className="level-text"><span className="level-mark"></span>Select a Template</div>
                  <div className="level-text "><span className="level-mark"></span>Job Goals</div>
                  <div className="level-text active"><span className="level-mark"></span>Work Info</div>
                  <div className="level-text"><span className="level-mark"></span>Finalize</div>
              </div>
          </div>
        <div className="screen screen-seven">
          <h1>What's your relevant job experience?</h1>
          <p>Select a recent job that's relevant to the position you're applying for.</p>
          <WorkHistoryForm data={{work_history:ques_ans_response.work_history}} save={(data)=>saveForm(data)}/>
          <div className="screen-action">
          <button className="round-btn" onClick={() => setBack(!back)}> <i className="arrow-bar-left"></i><span>Back</span></button>
          <button className="round-btn  active" onClick={() => setNext(!next)}><span>Next</span><i className="arrow-bar-right"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}

export default WorkHistory;